import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { pbdkf2 } from "../../Utils/OstreonEncryption";
import SHA from "sha.js";
import { useAuth } from "../../Context/AuthContext";
import styles from "./styles/Login.module.css";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import config from "../../config";
import { serverLogout } from "../../Utils/serverLogout";
import { RedirectionPopUp } from "./RedirectionPopUp";
import { useContext } from "react";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";
const base_url = config.base_url;
// import { getSHA256 } from "../../Utils/getSHA256";
export function Login() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.Login.login
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Login.login);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  // const [login_button_message, setButtonMessage] = useState(dublicatedcontent.dublicatedText3)
  const [disableButton, setButtonDisable] = useState(false);
  const [username, setUsername] = useState(
    window?.sessionStorage?.getItem("ostreon_username") || ""
  );
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(null);
  const [modal, showModal] = useState();
  const [error, setError] = useState({
    email: null,
    password: null,
  });
  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
    setButtonDisable(false);
  };
  const auth = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu";
    document.body.appendChild(script);
  }, []);
  useEffect(() => {
    // if (auth.otp)  serverLogout()
    auth.logout();
    serverLogout();
  }, []);
  const showError = (error, timelimit = 5000) => {
    setLoginError(error);
    setTimeout(() => {
      setLoginError(null);
    }, timelimit);
  };
  const handleLogin = async (token) => {
    let credentials = {};
    credentials.username = username;
    credentials.password = password;
    const [pbdkf2hash] = await pbdkf2(password, "OSTREON", 100000, 32 * 8);
    fetch(base_url + "login", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `username=${username}&password=${pbdkf2hash}&token=${token}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 429)
          setLoginError(dublicatedcontent?.dublicatedText51);
        else if (res.status === 403) setLoginError(content?.loginGeneralError1);
        else if (res.status === 500) setLoginError(content?.loginGeneralError2);
        else if (res.status === 498)
          setLoginError(dublicatedcontent?.dublicatedText49);
        else if (res.status === 404)
          setLoginError(content?.loginAccountNotActivatedError);
        else return res.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.error) showError(data.error);
        if (data.redirect_url)
          return showModal(
            <RedirectionPopUp
              redirect_url={data?.redirect_url}
              redirect_env={data?.region?.toUpperCase()}
              onClose={() => showModal()}
            />
          );
        else {
          const key = `${password}:${password}:${password}:OSTREON`;
          const hash = SHA("sha256").update(key).digest("hex");
          window.sessionStorage.setItem("ostreon_key", hash);
          // auth.login({"username":username, "ostreon_key": hash})                console.log(data)
          auth.login(data.success);
          auth.setEmail(username);
          // auth.updateHash(pbdkf2hash)
          if (data.success?.OTP === "true") {
            auth.setOTP(true);
            auth.setEmail(username);
            // auth.updateHash(pbdkf2hash)
            // navigate("/user/account", { replace: true });
            navigate("/user/dashboard", { replace: true });
          } else {
            // auth.updateHash(pbdkf2hash)
            navigate("./OTP", { replace: true });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        showError(dublicatedcontent?.dublicatedText78, 7000);
      })
      .finally((_) => {
        setButtonDisable(false);
      });
  };
  const submitCaptcha = (e) => {
    let emailValid = false,
      fieldChecked = false;

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(username)) {
      setError((prevError) => ({
        ...prevError,
        email: dublicatedcontent.dublicatedText47,
      }));
      setTimeout(() => {
        resetError();
      }, 5000);
    } else {
      emailValid = true;
    }

    if (password === "") {
      setError((prevError) => ({
        ...prevError,
        password: content.loginPasswordErrorMessage,
      }));
      setTimeout(() => {
        resetError();
      }, 5000);
    } else {
      fieldChecked = true;
    }

    if (!emailValid || !fieldChecked) {
      return;
    }

    e.preventDefault();
    setButtonDisable(true);
    // setButtonMessage('Processing...')
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute("6Ldi00MoAAAAAOhEarj3D8oPKndxNMGHPNVPeciu")
        .then((token) => {
          if (!username || !password) {
            return showError(content.loginGeneralError4);
          }
          handleLogin(token);
        })
        .catch((e) => {
          console.log(e);
          setButtonDisable(false);
        });
    });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      submitCaptcha(e);
    }
  };
  // password hide/show
  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };
  const [passwordVisibility, setPasswordVisibility] = useState({});

  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  return (
    <div className={styles.main_div}>
      <div
        className={styles.home_link}
        onClick={() => {
          window.location.href = formattingRedirectionUrl("");
        }}
      >
        {dublicatedcontent.dublicatedText41}
      </div>
      <div className={styles.title}>{content.loginTitle2}</div>
      <div className={styles.main_box}>
        <div className={styles.top}>
          <div className={styles.input_div}>
            <div className={styles.input_text}>
              {dublicatedcontent.dublicatedText74}
            </div>
            <input
              autoFocus
              onKeyDown={handleEnter}
              onClick={() => setError({ ...error, email: null })}
              className={error.email ? styles.input_error : styles.input}
              value={username}
              onChange={(e) => {
                setUsername(e.target.value.toLowerCase());
              }}
              placeholder={dublicatedcontent.dublicatedText74}
            ></input>
            {error?.email ? (
              <div className={styles.error_div}>
                <div className={styles.error_logo}></div>
                <div>{error?.email}</div>
              </div>
            ) : null}
          </div>

          <div className={styles.input_div}>
            <div className={styles.input_text}>
              {dublicatedcontent.dublicatedText62}
            </div>
            <input
              onClick={() => setLoginError()}
              onKeyDown={handleEnter}
              type={isPasswordVisible("passwordField") ? "text" : "password"}
              name="passwordField"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className={error.password ? styles.input_error : styles.input}
              placeholder={dublicatedcontent.dublicatedText62}
            />
            <div
              onClick={() => handleTogglePassword("passwordField")}
              className={styles.password_button}
            >
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                  fill="#B3B3B3"
                />
                <path
                  d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                  fill="#B3B3B3"
                />
              </svg>
            </div>
            {error?.password ? (
              <div className={styles.error_div}>
                <div className={styles.error_logo}></div>
                <div>{error?.password}</div>
              </div>
            ) : null}
          </div>

          <button
            disabled={disableButton}
            onClick={(e) => submitCaptcha(e)}
            className={styles.login_button}
          >
            {dublicatedcontent.dublicatedText3}
          </button>
          <div
            onClick={() => navigate("/login/recoverykey", { replace: false })}
            className={styles.forgot_your_password}
          >
            {content.loginText1}
          </div>
          {loginError ? (
            <div className={styles.login_error}>{loginError}</div>
          ) : null}
          <div className={styles.login_rect}></div>
        </div>
        <div className={styles.center}>
          <div className={styles.not_a_customer}>{content.loginText2}</div>
          <div
            onClick={() => navigate("/register", { replace: false })}
            className={styles.create_new_user}
          >
            {content.loginText3}
          </div>
          <div className={styles.login_rect}></div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.not_a_customer}>
            {content.loginText4}
            <span
              onClick={() => navigate("/beneficiary/login", { replace: false })}
              className={styles.login_beneficiary}
            >
              {dublicatedcontent.dublicatedText45}
            </span>
          </div>
        </div>
      </div>
      {modal}
    </div>
  );
}
